import type { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { templates } from "@reactivated";

export const Template = (
    props: Immutable<templates.BreadcrumbsBlockTemplate>,
): React.JSX.Element => {
    return (
        <nav className="breadcrumbs-block" aria-label={t`breadcrumbs`}>
            {props.ancestors.map((ancestor, i) => (
                <React.Fragment key={i}>
                    <a href={ancestor.url}>{ancestor.title}</a> /{" "}
                </React.Fragment>
            ))}
            {props.current_title}
        </nav>
    );
};
